<div class="container-fluid mt-2">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <button pButton pTooltip="Atualizar Registros" icon="pi pi-refresh" (click)="recarregaDados()"
        class="p-button-sm p-button-square mb-2 mt-2"></button>
    </div>
  </p-toolbar>

  <p-table #dt [value]="dados" [paginator]="true" [rows]="10" [loading]="loading" [autoLayout]="true"
    class="p-datatable-sm p-datatable-striped" [sortOrder]="1" [sortField]="'idPercentualClv'">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols">{{ col.header }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td>{{ rowData.idPercentualClv }}</td>
        <td>{{ rowData.descricao }}</td>
        <td>
          <ng-container *ngIf="!editingRows[rowData.idPercentualClv]; else editMode">
            {{ rowData.percentual }}%
          </ng-container>
          <ng-template #editMode>
            <input type="number" [(ngModel)]="rowData.percentual" class="p-inputtext p-component" />
          </ng-template>
        </td>
        <td>
          <ng-container *ngIf="!editingRows[rowData.idPercentualClv]; else saveCancelButtons">
            <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text"
              (click)="editarLinha(rowData)"></button>
          </ng-container>
          <ng-template #saveCancelButtons>
            <button pButton type="button" icon="pi pi-check" class="p-button-rounded p-button-text p-button-success"
              (click)="salvarLinha(rowData)"></button>
            <button pButton type="button" icon="pi pi-times" class="p-button-rounded p-button-text p-button-danger"
              (click)="cancelarEdicao(rowData)"></button>
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- <p-paginator *ngIf="totalRegistros > 10" [rows]="filtrosNew.quantidadeRegistrosPorPagina" [(first)]="first"
     (onPageChange)="onPageChange($event)"
    [showCurrentPageReport]="true">
  </p-paginator> -->

  <div class="card" *ngIf="dados?.length === 0">
    <div class="card-body bg-no-records p-shadow-3">
      <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
    </div>
  </div>

</div>
